/*global google*/
import React from 'react';
import { useState } from 'react';
import axios from 'axios';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '95vh'
};

const center = {
    lat: 23.275412,
    lng: 79.075017
};

   // prod
//    googleMapsApiKey : "AIzaSyAr-n9zN3vYDBaPtINPgPQi70DGtHUiyfE"
   // local
                    //    googleMapsApiKey: "AIzaSyD4X4kzlpReymgcXUXGh0Q3TalmxJmasM0",

function MyComponent() {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
       googleMapsApiKey : "AIzaSyAr-n9zN3vYDBaPtINPgPQi70DGtHUiyfE" 
    })
    const [map, setMap] = useState(null)
    const onLoad = React.useCallback(function callback(map) {
        function firstFunction1() {
            return new Promise((resolve, reject) => {
                const y = axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/trancropsurveypolygon/getPolygonbyUserCode`, {"createdByUC": localStorage.getItem("userCodeGlobal")})
                resolve(y)

            })
        }
        async function secondFunction1() {
            const result = await firstFunction1()
            var response_value = JSON.stringify(result.data.dataContent)
            let mylocalvalue = JSON.parse(response_value);
            var myFinalArray = [];
            var myInfoWindow = [];
            var myPolygon;
            var myPolygon = [];
            var myMarker = []
            var CropSurveyCode = []
            for (let i = 0; i < mylocalvalue.length; i++) {
                CropSurveyCode.push(JSON.parse(mylocalvalue[i].cropSurveyCode))
                myPolygon[i] = "myPolygon" + [i];
                let poylShape = []
                try {
                    poylShape = JSON.parse(mylocalvalue[i].polygonShape)
                } catch (error) {
                    
                }
                myFinalArray.push(poylShape)
                myPolygon[i] = new window.google.maps.Polygon({
                    paths: myFinalArray,
                    strokeColor: '#FF0000',
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: '#FF0000',
                    fillOpacity: 0.1,
                    content: 'Crop Survey Code ' + CropSurveyCode
                });

                google.maps.Polygon.prototype.my_getBounds=function(){
                    var bounds = new google.maps.LatLngBounds()
                    myPolygon[i].getPath().forEach(function(element,index){bounds.extend(element)})
                    return bounds
                }
                
                myPolygon[i].setMap(map);
                myInfoWindow[i] = new google.maps.InfoWindow;
                myPolygon[i].addListener('mouseover', function (event) {
                    myPolygon[i].setEditable(!myPolygon[i].getEditable());
                    myInfoWindow[i].setContent(this.content);
                    myInfoWindow[i].setPosition(event.latLng);
                    myInfoWindow[i].open(map);
                });
                myPolygon[i].addListener('mouseout', function (event) {
                    myInfoWindow[i].close();
                });
                myFinalArray = [];
                CropSurveyCode = []

                
            
                    myMarker[i] =  new google.maps.Marker({
                        position: myPolygon[i].my_getBounds().getCenter(),
                        map: map,
                        title: "Click to zoom",

                      })

                      myMarker[i].addListener("click", () => {
                        map.panTo(myMarker[i].getPosition());
                        map.setZoom(18);
                      });    

            }
        };
        secondFunction1()
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    return isLoaded ? (
        <>
            {/* <AdminHeader />
            <AdminSideBar /> */}
             {/* <AdminSideBar /> */}
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={5.3}
                onLoad={onLoad}
                onUnmount={onUnmount}
                mapTypeId="satellite"
            >
                <></>
            </GoogleMap>
            {/* <AdminFooter /> */}
        </>
    ) : <></>
}

export default React.memo(MyComponent)